var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFreeAndAnonymous = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#81B90C",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  clipPath: "url(#clip0_10689_73338)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m12.594 6.8 1.4 2.95h2.377a.65.65 0 0 1 .47 1.114l-2.188 1.946 1.21 2.778a.657.657 0 0 1-.939.823l-2.923-1.644-2.923 1.644a.658.658 0 0 1-.938-.823l1.21-2.778-2.184-1.946a.651.651 0 0 1 .47-1.114h2.376l1.4-2.95a.665.665 0 0 1 1.182 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m12.577 1.014 1.878 2.16a.77.77 0 0 0 .748.244l2.79-.645a.764.764 0 0 1 .932.678l.25 2.852a.76.76 0 0 0 .462.636l2.636 1.119a.762.762 0 0 1 .356 1.1l-1.475 2.454a.76.76 0 0 0 0 .786l1.475 2.454a.763.763 0 0 1-.356 1.1l-2.636 1.119a.76.76 0 0 0-.462.636l-.25 2.852a.763.763 0 0 1-.932.678l-2.79-.645a.77.77 0 0 0-.748.243l-1.878 2.162a.764.764 0 0 1-1.152 0l-1.878-2.17a.77.77 0 0 0-.748-.243l-2.79.645a.764.764 0 0 1-.932-.678l-.25-2.85a.76.76 0 0 0-.462-.636l-2.636-1.121a.763.763 0 0 1-.356-1.1l1.475-2.454a.76.76 0 0 0 0-.786l-1.475-2.45a.763.763 0 0 1 .356-1.1l2.636-1.115a.76.76 0 0 0 .462-.638l.25-2.852a.764.764 0 0 1 .932-.678l2.79.645a.77.77 0 0 0 .748-.243l1.878-2.161a.764.764 0 0 1 1.152.002"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_10689_73338"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})))));
export { SvgFreeAndAnonymous as ReactComponent };